import '../style/radio-group-CjshsMhg.css'
import { defineComponent as k, computed as c, toRef as E, ref as V, watch as _, openBlock as a, createElementBlock as l, unref as s, normalizeClass as v, Fragment as B, renderList as L, normalizeStyle as D, createElementVNode as n, withDirectives as w, vModelRadio as x, renderSlot as U, toDisplayString as A } from "vue";
import { UPDATE_MODEL_VALUE as f } from "./constant/events.js";
import { useFormItem as C } from "./hooks/useFormItem.js";
import { useElementId as F } from "./hooks/useElementId.js";
import { useInputSize as M } from "./hooks/useInputSize.js";
const N = ["id", "aria-label"], R = ["for"], $ = { class: "e-radio__dot-wrapper" }, O = ["id", "value", "name", "disabled"], P = /* @__PURE__ */ n("span", { class: "e-radio__dot" }, null, -1), T = {
  key: 1,
  class: "e-radio__label"
}, K = /* @__PURE__ */ k({
  name: "e-radio-group",
  __name: "radio-group",
  props: {
    modelValue: { type: [Number, String, Boolean] },
    options: {},
    name: {},
    reverse: { type: Boolean },
    vertical: { type: Boolean },
    size: {},
    itemStyle: {}
  },
  emits: [f],
  setup(g, { emit: b }) {
    const t = g, y = b, S = c(() => t.options.length), { elementIds: d } = F("radio-group", S), { formItem: p, formSize: h } = C(), { actualSize: u } = M({ formSize: h, propSize: E(t, "size") }), r = V(t.modelValue), z = c(() => {
      const { vertical: e } = t;
      return [
        "e-radio-group",
        {
          [`e-radio-group--${u.value}`]: u.value,
          "e-radio-group--vertical": e
        }
      ];
    });
    return _(() => t.modelValue, (e) => r.value = e), _(r, (e) => y(f, e)), (e, m) => (a(), l("div", {
      id: s(p).formItemId,
      "aria-label": s(p).label ?? "radio-group",
      class: v(z.value),
      role: "radiogroup",
      tabindex: "0"
    }, [
      (a(!0), l(B, null, L(e.options, (o, i) => (a(), l("label", {
        key: i,
        for: s(d)[i],
        class: v(["e-radio", { "e-radio--reverse": e.reverse, "e-radio--disabled": o.disabled }]),
        style: D(e.itemStyle)
      }, [
        n("span", $, [
          w(n("input", {
            id: s(d)[i],
            "onUpdate:modelValue": m[0] || (m[0] = (I) => r.value = I),
            type: "radio",
            value: o.value,
            name: e.name,
            disabled: o.disabled
          }, null, 8, O), [
            [x, r.value]
          ]),
          P
        ]),
        o.textSlot ? U(e.$slots, o.textSlot, {
          key: 0,
          text: o.text
        }) : (a(), l("span", T, A(o.text), 1))
      ], 14, R))), 128))
    ], 10, N));
  }
});
export {
  K as default
};
//# sourceMappingURL=radio-group.js.map
